(function () {
  const el = document.querySelector('[data-deadline]');
  if (!el) return;

  const deadlineRaw = el.getAttribute('data-deadline');
  if (!deadlineRaw) return;

  const dd = el.querySelector('[data-dd]');
  const hh = el.querySelector('[data-hh]');
  const mm = el.querySelector('[data-mm]');
  const ss = el.querySelector('[data-ss]');

  const deadline = new Date(deadlineRaw);

  function tick() {
    const now = new Date();
    let diff = Math.max(0, deadline - now);

    const days = Math.floor(diff / 86400000); diff -= days * 86400000;
    const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
    const mins = Math.floor(diff / 60000); diff -= mins * 60000;
    const secs = Math.floor(diff / 1000);

    if (dd) dd.textContent = String(days);
    if (hh) hh.textContent = String(hours).padStart(2, '0');
    if (mm) mm.textContent = String(mins).padStart(2, '0');
    if (ss) ss.textContent = String(secs).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
})();